import React, { useEffect, useState } from "react";
import TextField from "../../../components/inputs/textfield";
import Snackbar from "../../../components/snackbar/snackbar";
import { admin_mous_edit, get_mou_details } from "../admin.api";
import { useParams } from "react-router-dom";

import "./view.css";
import { FormValidate } from "../../../components/formValidate";
import CommonForm from "../../../components/commonform/commonForm";
let required = [
  "organization_name",
  "logo",
];
let fiveYearsAgo = new Date();
fiveYearsAgo.setFullYear(fiveYearsAgo.getFullYear() - 5, 0, 1);
const today = new Date();
const fiveYearsAfter = new Date(today.getFullYear() + 5, 11, 31);
const endOfYear = new Date(today.getFullYear(), 11, 31);

export default function EditMou(props) {
  const [basicData, setBasicData] = useState({});

  const selectedParam = useParams();
  const getMouDtails = () => {
    if (!selectedParam?.id) {
      console.error("selectedParam.id is undefined:", selectedParam);
      return;
    }

    get_mou_details(selectedParam.id)
    .then((res) => {
      if (res?.Mou) {
        const { from_date, to_date, ...rest } = res.Mou;

        let formattedFromDate = from_date;
        if (from_date) {
          const [year, month, day] = from_date.split('-');
          formattedFromDate = `${day}-${month}-${year}`;
        }
        let formattedToDate = from_date;
        if (to_date) {
          const [year1, month1, day1] = to_date.split('-');
          formattedToDate = `${day1}-${month1}-${year1}`;
        }

        setBasicData({
          ...rest,
          from_date: formattedFromDate,
          to_date: formattedToDate,

        });
      }
    })
      .catch((err) => console.error("Error fetching MOU details:", err));
  };


  useEffect(() => {
    getMouDtails();
  }, [selectedParam]);
  

  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [fileChanged, setFileChanged] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [err, setErr] = useState(false);
  const [keyvalue, setKeyValue] = useState(1);

  const handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let data = basicData;
    data = {
      ...data,

      [name]: value,
    };
    setBasicData(data);
  };


  const handlePhotoFileChange = (e) => {
    let flag = false;
    let type = e.target.files[0].name.split(".").pop();

    if (type === "png" || type === "jpeg" || type === "jpg") {
      var reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = function (e) {
        var image = new Image();
        image.src = e.target.result;

        image.onload = function () {
          var height = this.height;
          var width = this.width;

          if (height === 400 || width === 400) {
            flag = true;
          }
        };
      };
      setTimeout(() => {
        if (flag) {
          setFileChanged(true);
          setBasicData({
            ...basicData,
            file_name_photo: e.target.files[0].name,
            [e.target.name]: e.target.files[0],
          });
        } else {
          setSnackMessage("Incorrect image dimension");
          setIsSnackError(true);
          setSnackOpen(true);
        }
      }, 200);
    } else {
      setSnackMessage("File should be in .jpg / .jpeg / .png format");
      setIsSnackError(true);
      setSnackOpen(true);
    }
  };

  const handleDatePickerChange = (e, name) => {
    let date = e.value;
    const dateRegex = /^[0-9]{2}-[0-9]{2}-[0-9]{4}$/;
    if (dateRegex.test(date)) {
      setErr(false);
    } else {
      setErr(true);
    }
    setBasicData({ ...basicData, [name]: date });
    setKeyValue(keyvalue + 1);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = FormValidate(basicData, required);
    setIsActive(true);
    if (Object.keys(errors).length === 0) {
      let id = basicData.id;
      const form = new FormData();
      form.append("id", basicData?.id);
      form.append("organization_name", basicData?.organization_name);
      basicData?.kspace_signatory_area ? form.append("kspace_signatory_area", basicData?.kspace_signatory_area) : form.append("kspace_signatory_area", "");
      basicData?.partner_signatory_area ? form.append("partner_signatory_area", basicData?.partner_signatory_area) : form.append("partner_signatory_area", "");
      const [day, month, year] = basicData.from_date.split("-");
      form.from_date = `${year}-${month}-${day}`;
      form.append("from_date", form?.from_date);

      const [day1, month1, year1] = basicData.to_date.split("-");
      form.to_date = `${year1}-${month1}-${day1}`;
      form.append("to_date", form?.to_date);
      if (basicData?.logo && basicData.logo[0] instanceof File) {
        form.append("logo", basicData.logo[0]);
      }
  

      admin_mous_edit(id, form)
        .then((res) => {
          setSnackMessage(res.message);
          setIsSnackError(false);
          setSnackOpen(true);
        })
        .catch((error) => {
          setSnackMessage(error.message);
          setIsSnackError(true);
          setSnackOpen(true);
        });
    }
    else {
      setSnackMessage("Please fill all mandatory fields");
      setIsSnackError(true);
      setSnackOpen(true);
      setIsActive(false);
    }
  }


  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      props.history.push("/admin-mou");
    }
  };


  return (
    <div className="add-per">
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      <div className="view-container">
        <h6>
          <b>Edit MOU</b>
        </h6>
        <hr />
        <button
          type="button"
          className="btn btn-primary btn-sm  mb-3"
          onClick={(e) => {
            props.history.push("/admin-mou");
          }}
        >
          Back
        </button>

        <div className="row">
          <div className="col-12">
            <TextField
              fullwidth
              label="Organization"
              // multiline
              required
              value={basicData?.organization_name ?? ""}
              onChange={(e) => handleChange(e)}
              name="organization_name"
              id="organization_name"
              aria-describedby="emailHelp"
            />
          </div>
          <div className="col-12">
            <TextField
              fullwidth
              label="Signatory from KSPACE"
              multiline
              value={basicData?.kspace_signatory_area ?? ""}
              onChange={(e) => handleChange(e)}
              name="kspace_signatory_area"
              id="kspace_signatory_area"
              aria-describedby="emailHelp"
            />
          </div>
          <div className="col-12">
            <TextField
              type="text"
              label="Signatory from partner organization"
              multiline
              value={basicData?.partner_signatory_area ?? ""}
              onChange={(e) => handleChange(e)}
              name="partner_signatory_area"
              id="partner_signatory_area"
              aria-describedby="emailHelp"
            />
          </div>
          <div className="col-12">
            <CommonForm
              fieldType="date"
              label={`Date From `}
              required
              name="from_date"
              minDate={new Date(fiveYearsAgo)}
              maxDate={endOfYear}
              value={basicData?.from_date ?? ""}
              onChange={(e) => {
                handleDatePickerChange(e, "from_date");
              }}
              {...props}
            />
          </div>
          <div className="col-12">
            <CommonForm
              fieldType="date"
              label={`Date To `}
              required
              name="to_date"
              minDate={today}
              maxDate={fiveYearsAfter}
              value={basicData?.to_date ?? ""}
              onChange={(e) => {
                handleDatePickerChange(e, "to_date");
              }}
              {...props}
            />
          </div>

          <div className="col-12">

            <TextField
              label="Logo"
              required
              id="formFileSm"
              onChange={(e) => handlePhotoFileChange(e)}
              accept=".jpg,.jpeg,.png"
              fileName={basicData.file_name_photo ? basicData.file_name_photo : basicData.logo}
              name="logo"
              type="file"
            />
            <small className="pers">
              *Upload only .jpg , .jpeg , .png format and Size should be less
              than 1MB of width: 400 Height: 400
            </small>
          </div>

          <div className="col-12">
            <center>
              <button
                type="button"
                className="btn btn-dark mt-3"
                onClick={(e) => handleSubmit(e)}
              >
                Submit for Acceptance
              </button>
            </center>
          </div>
          {/* ---------------- */}
        </div>
      </div>
    </div>
  );
}
